function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect } from "react";
import { ElementType, ImageActionType, ImageSize } from "../../../shared/types";
import { backgroundImageOverlayStyles } from "../../../shared/utils/styles";
import { LazyLightBox } from "../../../shared/Components/LightBox";
import { ElementPlaceholder } from "../../../shared/Components/ElementPlaceholder/ElementPlaceholder";
const ImageView = ({
  element,
  elementRef,
  elementSize,
  elementContentRef,
  wuiltContext
}) => {
  const imageSettings = element?.settings;
  const contextElements = wuiltContext?.base;
  const imageActionValue = imageSettings?.content?.action?.value;
  const shouldOpenInANewTab = imageSettings?.content?.action?.shouldOpenInANewTab;
  let originalImageElement;
  useEffect(() => {
    originalImageElement = document.createElement("img");
  }, []);
  if (originalImageElement) {
    originalImageElement.src = imageSettings?.content?.src || "";
  }
  const aspectRatio = (originalImageElement?.naturalWidth ?? 0) / (originalImageElement?.naturalHeight ?? 1);
  const imageWidthLimit = aspectRatio * (elementSize?.height ?? 1);
  const [showLightBox, setShowLightBox] = React.useState(false);
  const [isImageWidthMinimized, setIsImageWidthMinimized] = React.useState(false);
  React.useEffect(() => {
    if (!isImageWidthMinimized && (elementContentRef?.current?.clientWidth ?? 0) == elementSize?.width) {
      setIsImageWidthMinimized(true);
    } else if (isImageWidthMinimized && elementSize?.width > imageWidthLimit) {
      setIsImageWidthMinimized(false);
    }
  }, [isImageWidthMinimized, elementContentRef, elementSize?.width]);
  const imageSrc = imageSettings?.content?.src;
  const shouldImageFill = imageSettings?.design?.size === ImageSize.Cover;
  const shouldImageDoNothing = imageSettings?.content?.action?.type === ImageActionType.DoNothing;
  const shouldImageScaleUp = imageSettings?.content?.action?.type === ImageActionType.ScaleUp;
  const isInternalLinkAction = imageSettings?.content?.action?.type === ImageActionType.InternalLink;
  const isExternalLinkAction = imageSettings?.content?.action?.type === ImageActionType.ExternalLink;
  const shouldImageOpenALink = isInternalLinkAction || isExternalLinkAction;
  const ActionComponent = isExternalLinkAction ? contextElements?.Link : isInternalLinkAction ? contextElements?.PageLink : "div";
  const imageActionLinkProps = shouldImageDoNothing || !shouldImageOpenALink && !shouldImageScaleUp ? {} : {
    href: imageActionValue,
    page: {
      id: imageActionValue
    },
    target: shouldOpenInANewTab ? "_blank" : "_self",
    ...(shouldImageScaleUp ? {
      onClick: handleScaleUpImage
    } : {})
  };
  const imageStyles = imageSettings?.content?.src ? backgroundImageOverlayStyles(imageSettings?.design?.overlay) : {};
  function handleScaleUpImage() {
    setShowLightBox(true);
  }
  return /*#__PURE__*/React.createElement("div", {
    ref: elementRef,
    id: element?.id,
    "data-test": "ImageView",
    style: {
      width: shouldImageFill || !imageSrc ? "100%" : "fit-content",
      height: shouldImageFill || !imageSrc ? "100%" : "fit-content"
    }
  }, /*#__PURE__*/React.createElement("style", null, `
          .yarl__navigation_next, .yarl__navigation_prev {
            display: none;
          }
        `), imageSettings?.content?.src ? /*#__PURE__*/React.createElement(ActionComponent, _extends({
    style: {
      display: "block",
      width: shouldImageFill ? "100%" : "fit-content",
      height: shouldImageFill ? "100%" : "fit-content",
      cursor: shouldImageOpenALink || shouldImageScaleUp ? "pointer" : undefined
    }
  }, imageActionLinkProps), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderStartStartRadius: imageSettings?.design?.borderRadius?.startStart,
      borderStartEndRadius: imageSettings?.design?.borderRadius?.startEnd,
      borderEndStartRadius: imageSettings?.design?.borderRadius?.endStart,
      borderEndEndRadius: imageSettings?.design?.borderRadius?.endEnd,
      ...imageStyles
    }
  }), /*#__PURE__*/React.createElement("img", {
    ref: elementContentRef,
    src: imageSettings?.content?.src,
    alt: imageSettings?.content?.alt,
    title: imageSettings?.content?.alt,
    style: {
      width: shouldImageFill ? "100%" : "auto",
      maxWidth: shouldImageFill ? "100%" : elementSize?.width,
      height: shouldImageFill ? "100%" : elementSize?.height,
      maxHeight: shouldImageFill ? "100%" : elementSize?.height,
      objectPosition: "50% 50%",
      overflow: "hidden",
      objectFit: imageSettings?.design?.size,
      borderStartStartRadius: imageSettings?.design?.borderRadius?.startStart,
      borderStartEndRadius: imageSettings?.design?.borderRadius?.startEnd,
      borderEndStartRadius: imageSettings?.design?.borderRadius?.endStart,
      borderEndEndRadius: imageSettings?.design?.borderRadius?.endEnd
    }
  }), /*#__PURE__*/React.createElement(React.Suspense, {
    fallback: null
  }, shouldImageScaleUp && /*#__PURE__*/React.createElement(LazyLightBox, {
    open: showLightBox,
    carousel: {
      finite: true,
      padding: 0
    },
    zoom: {
      maxZoomPixelRatio: 3,
      scrollToZoom: true
    },
    close: () => setShowLightBox(false),
    slides: [{
      src: imageSettings?.content?.src
    }]
  }))) : /*#__PURE__*/React.createElement(ElementPlaceholder, {
    elementType: ElementType.Image
  }));
};
export { ImageView };
//# sourceMappingURL=ImageView.js.map